module.exports = __webpack_public_path__ + "img/mlb-back-2-p-800.457db3cb.png";